import React from "react";
import { ListGroupItem } from "react-bootstrap";

type State<T> = [T, (t: T) => void];

export function listGroupSelection<T>(
    label: string,
    value: T,
    [currentVal, setValue]: State<T>,
) {
    return value === currentVal ? (
        <ListGroupItem active>{label}</ListGroupItem>
    ) : (
        <ListGroupItem onClick={() => setValue(value)}>{label}</ListGroupItem>
    );
}
